import { defineModel, serializable, castings as castTo } from '../model'

class Organizer {
    /**
     * ...
     */
    @castTo.model('AddressLocation')
    @serializable()
    addressContact: ApiModel<'AddressLocation'>

    @serializable()
    custom: string
}

export default defineModel(Organizer)
